import clnt from './images/client.png';
import dld from './images/exls.png';
import vnd from './images/vendor.jpeg';
import tst from './images/test.png';
import usr from './images/user.jpeg';
import { ExportCSV } from './exportCSV';
import { useEffect, useState } from 'react';
import axios from 'axios';
function Reports()
{
    let [dataclients,setClientData]=useState([]);
    let [datavendors,setVendorData]=useState([]);
    let [datausers,setUserData]=useState([]);
    let [datatests,setTestData]=useState([]);
    let [datasamples,setSampleData]=useState([]);
    let [prg,setPrg]=useState("none");
    async function loadAllLists()
    {
        setPrg("block");
        await axios.get(process.env.REACT_APP_APIURL+"clients.php").then(reply=>
        {
            if(reply.status==200 && reply.data.status=="OK")
            {
                setClientData(reply.data.data);
            }
        });
        await axios.get(process.env.REACT_APP_APIURL+"vendors.php").then(reply=>
        {
            if(reply.status==200 && reply.data.status=="OK")
            {
                setVendorData(reply.data.data);
            }
        });
        
        await axios.get(process.env.REACT_APP_APIURL+"users.php").then(reply=>
        {
            if(reply.status==200 && reply.data.status=="OK")
            {
                setUserData(reply.data.data);
            }
        });  
        await axios.get(process.env.REACT_APP_APIURL+"tests.php").then(reply=>
        {
            if(reply.status==200 && reply.data.status=="OK")
            {
                setTestData(reply.data.data);
            }
        });  
        setPrg("none");
    }
    async function showData(event)
    {
        setPrg("block");
        let start=document.getElementById("dtstart").value;
        let end=document.getElementById("dtend").value;
        let cid=document.getElementById("drpclient").value;
        let tid=document.getElementById("drptest").value;
        await axios.get(process.env.REACT_APP_APIURL+"samples.php?start="+start+"&end="+end).then(reply=>
        {
            if(reply.status=200 && reply.data.status=="OK")
            {
                let arr=reply.data.data;
                if(cid!="0")
                {
                    arr=arr.filter((e)=>e.cid==cid);
                }
                if(tid!="0")
                {
                    arr=arr.filter((e)=>e.tid==tid);
                }
                for(let i=0;i<arr.length;i++)
                {
                    delete arr.trftype;
                    delete arr.reporttype;
                    delete arr.rawtype;
                }
                setSampleData(arr);
            }
        });
        setPrg("none");
    }
    useEffect(()=>{
        loadAllLists();
    },[]);
    return(
        <div className='p-2'>
            <div style={{position:'fixed',left:'48%',top:'48%',display:prg}}><span className='spinner-border text-primary'></span></div>
            <div className="row">            
                <div className="col-3 p-2">
                    <div className="border shadow rounded-3 p-2 text-center">
                        <img src={clnt} className='w-25' /><br/>
                        <ExportCSV btnClass="btn btn-sm btn-primary mt-2" lblButton="Client List &#x21d3;" csvData={dataclients} fileName="clientlist" />                                        
                    </div>                
                </div>
                <div className="col-3 p-2">
                    <div className="border shadow rounded-3 p-2 text-center">
                        <img src={vnd} className='w-25' /><br/>
                        <ExportCSV btnClass="btn btn-sm btn-primary mt-2" lblButton="Vendor List &#x21d3;" csvData={datavendors} fileName="vendorlist" />                                        
                    </div>                
                </div>
                <div className="col-3 p-2">
                    <div className="border shadow rounded-3 p-2 text-center">
                        <img src={tst} className='w-25' /><br/>
                        <ExportCSV btnClass="btn btn-sm btn-primary mt-2" lblButton="Tests List &#x21d3;" csvData={datatests} fileName="testslist" />                                        
                    </div>                
                </div>
                <div className="col-3 p-2">
                    <div className="border shadow rounded-3 p-2 text-center">
                        <img src={usr} className='w-25' /><br/>
                        <ExportCSV btnClass="btn btn-sm btn-primary mt-2" lblButton="Users List &#x21d3;" csvData={datausers} fileName="userslist" />                                        
                    </div>                
                </div> 
                <hr/>
                <div className='col-12'>
                    <div className='row'>
                        <div className='col-xxl-2 col-xl-2 col-lg-2 col-3 p-2'>
                            <input type="date" onChange={showData} id="dtstart" className='form-control form-control-sm' />
                        </div>
                        <div className='col-xxl-2 col-xl-2 col-lg-2 col-3 p-2'>
                            <input type="date" onChange={showData} id="dtend" className='form-control form-control-sm' />
                        </div>
                        <div className='col-xxl-2 col-xl-2 col-lg-2 col-3 p-2'>
                            <select id="drpclient" onChange={showData} className='form-control form-control-sm' >
                                <option value="0">All Clients</option>
                                {dataclients.map((e,i)=>
                                    <option value={e.cid}>{e.cname}</option>
                                )}  
                            </select>
                        </div>
                        <div className='col-xxl-2 col-xl-2 col-lg-2 col-3 p-2'>
                            <select id="drptest" onChange={showData} className='form-control form-control-sm' >
                                <option value="0">All Tests</option>
                                {datatests.map((e,i)=>
                                    <option value={e.tid}>{e.testname}</option>
                                )}
                            </select>
                        </div>
                    </div>
                    <hr/>
                    <div style={{overflow:"auto",fontSize:'12px'}} className='col-12'>
                        <table className='table table-bordered table-striped'>
                            <thead>
                            <tr>
                                <th>S.No</th>
                                <th>Sample</th>
                                <th>Test Name</th>
                                <th>Client</th>
                                <th>Receiving Date</th>
                                <th>Delivery Date</th>
                                <th>Status</th>                                
                            </tr>
                            </thead>
                            <tbody>
                                {datasamples.map((e,i)=>
                                    <tr>
                                        <td>{i+1}</td>
                                        <td>{e.sname}</td>
                                        <td>{e.tname}</td>
                                        <td>{e.cname}</td>
                                        <td>{e.rdate}</td>
                                        <td>{e.ddate}</td>
                                        <td>{e.status}</td>                                        
                                    </tr>
                                )}
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td colSpan="7" style={{textAlign:"right"}}><ExportCSV btnClass="btn btn-sm btn-success mt-2" lblButton="Sample List &#x21d3;" csvData={datasamples} fileName="samplelist" /></td>
                                </tr>
                            </tfoot>
                        </table>                                    
                    </div>
                </div>
            </div>
        </div>
        
    );
}
export default Reports;